import { createStore } from 'satcheljs';
import { IWindowsAppFeatureFlag } from '../types';

export const getStore = createStore<IWindowsAppFeatureFlag>('WindowsAppFeatureFlag', {
  isLoading: false,
  isFeatureEnabled: undefined,
});
